import secureApi from "../services/secureApi";

export const getSiteSettings = async () => {
  const response = await secureApi.get("/admin/masterData");
  return response.data;
};

export const saveSiteSettings = async (settings) => {
  const response = await secureApi.put("/admin/settings/save", settings);
  return response.data;
};
